// src/components/EventCard.js

import React from 'react';

const EventCard = ({ event }) => {
  // Tarih ve saati birleştirip formatlıyoruz
  const formattedDateTime = `${event.date.toUpperCase()} • ${event.time}`;

  return (
    <div className="event-card">
      <div className="event-card-poster">
        <img src={event.posterUrl} alt={`Poster for ${event.name}`} loading="lazy" />
      </div>
      <div className="event-card-content">
        <h3 className="event-name">{event.name}</h3>
        <p className="event-location">{event.location}</p>
        <p className="event-datetime">{formattedDateTime}</p>
      </div>
    </div>
  );
};

export default EventCard;